var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background":"#F6F6F6","padding-bottom":"30px"}},[_c('ZYtoolsHead'),_c('div',{staticClass:"wrap"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }